import './fading.less';

export function fadeOut(el: HTMLElement) {
    setTimeout(() => {
        el.classList.add('fading-out');
        el.classList.remove('faded', 'fading-in');
    }, 0);
    
}

export function fadeIn(el: HTMLElement) {
    el.classList.add('faded');
    setTimeout(() => {
        el.classList.add('fading-in');
        el.classList.remove('faded', 'fading-out');
    }, 0);    
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./Frontend/src/animations/fading.ts